export default __webpack_public_path__ + "images/1ab19ecbba2d491f2aca078f45a3e88a-thrive-logo.svg";